
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7157_429239)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#51AA1C"}},[_c('path',{attrs:{"d":"M13.63 16.445C15.89 10.872 21.553 5.601 30 5.601c9.088 0 16.834 6.183 18.532 16.19 2.398.358 4.908 1.277 6.976 2.813 2.57 1.908 4.492 4.816 4.492 8.7 0 3.765-1.585 6.76-4.166 8.768-2.53 1.968-5.897 2.904-9.428 2.904H37.5a1.875 1.875 0 010-3.75h8.906c2.915 0 5.407-.777 7.125-2.114 1.668-1.297 2.719-3.2 2.719-5.808 0-2.49-1.183-4.356-2.978-5.69-1.842-1.368-4.284-2.125-6.49-2.235a1.875 1.875 0 01-1.772-1.677C44.066 14.663 37.57 9.35 30 9.35c-7.148 0-11.717 4.715-13.215 9.385a1.875 1.875 0 01-1.608 1.294C8.717 20.643 3.75 24.62 3.75 30.632c0 6.042 5.221 10.594 12.188 10.594H22.5a1.875 1.875 0 110 3.75h-6.563C7.435 44.976 0 39.242 0 30.632c0-8.19 6.483-13.082 13.63-14.187z"}}),_c('path',{attrs:{"d":"M28.674 21.15a1.875 1.875 0 012.652 0l7.5 7.5a1.875 1.875 0 11-2.652 2.651L30 25.127l-6.174 6.174a1.875 1.875 0 01-2.652-2.651l7.5-7.5z"}}),_c('path',{attrs:{"d":"M30 22.476c1.035 0 1.875.84 1.875 1.875v28.174a1.875 1.875 0 01-3.75 0V24.35c0-1.036.84-1.875 1.875-1.875z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7157_429239"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h60v60H0z"}})])])])
          )
        }
      }
    